import { useState, useEffect } from 'preact/hooks'
import Icon from '@/components/snippets/icon/icon'
import { formatMoney } from '@/components/helpers/currency-formatter'
import { PRICE_FILTER_FIELD } from './FilterUtils'
import { globalState } from '@/components/helpers/utils'
import { isSizeFilter, formatUniversalSizeValue } from './SizeFilterUtils'

export function FilterSelected({ activeFilters, onRemove }) {
  const [, forceUpdate] = useState(0)

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'preferred_size_range' || e.key === null) {
        forceUpdate(prev => prev + 1)
      }
    }

    const handleSizeTypeChange = () => {
      forceUpdate(prev => prev + 1)
    }

    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('preferred_size_range_changed', handleSizeTypeChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('preferred_size_range_changed', handleSizeTypeChange)
    }
  }, [])

  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')

    if (field === PRICE_FILTER_FIELD) {
      const [min, max] = value.split('<->')
      const formatMin = parseFloat(min) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      const formatMax = parseFloat(max) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      return `${formatMoney(parseFloat(min) * 100, formatMin)} - ${formatMoney(parseFloat(max) * 100, formatMax)}`
    }

    if (isSizeFilter(field, value)) {
      return formatUniversalSizeValue(value)
    }

    return value
  }

  return (
    <div className="flex py-1 border-b border-neutral-light">
      <div className="grow flex gap-x-0.5 px-1 md:px-1.5 overflow-x-scroll no-scrollbar overscroll-none">
        {[...activeFilters].map((filter) => {
          const displayValue = formatFilterValue(filter)
          return (
            <button class="shrink-0 btn btn-light btn-fill btn-xs !font-normal" onClick={() => onRemove(filter)} aria-label={`Remove ${displayValue} filter`}>
              {displayValue}
              <div className="flex size-[9px] children:size-full">
                <Icon id="close" />
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
